import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Keşif & Analiz",
    desc: "İhtiyaçlarınızı dinliyor, rakiplerinizi ve hedef kitlenizi analiz ediyoruz.",
  },
  {
    n: "02",
    title: "Strateji",
    desc: "Markanız için en uygun dijital yol haritasını ve KPI'ları çıkarıyoruz.",
  },
  {
    n: "03",
    title: "Tasarım & Geliştirme",
    desc: "Modern arayüzler ve veri odaklı reklam kampanyalarınızı inşa ediyoruz.",
  },
  {
    n: "04",
    title: "Yayına Alma & Büyüme",
    desc: "Sistemi teslim ediyor, sürekli optimizasyonla büyümenizi sağlıyoruz.",
  },
];

export default function Process() {
  return (
    <section
      id="surec"
      data-testid="process-section"
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="ab-chip">Nasıl Çalışıyoruz</span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl font-extrabold text-[var(--ab-navy)] leading-tight">
              Şeffaf bir süreç,
              <br />
              <span className="ab-text-gradient">ölçülebilir</span> sonuçlar.
            </h2>
            <p className="mt-5 text-lg text-slate-600 max-w-md">
              Projenizin her aşamasında size raporlama yapar, kararları birlikte
              alırız. Sürpriz değil, sonuç istiyoruz.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                data-testid={`process-step-${i}`}
                className="flex gap-5 sm:gap-7 p-6 sm:p-7 rounded-2xl border border-slate-200 bg-white hover:border-[var(--ab-blue)]/40 hover:shadow-[0_18px_38px_-22px_rgba(10,19,48,0.18)] transition-all"
              >
                <div className="font-display text-4xl sm:text-5xl font-extrabold ab-text-gradient leading-none shrink-0 w-16 sm:w-20">
                  {s.n}
                </div>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-[var(--ab-navy)]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
